module.exports = __webpack_public_path__ + "static/img/poster_sl03.0412292f.jpg";